import type { components } from './schema';

type S = components['schemas'];

export type Country = S['CountryOut'];
export type Region = S['RegionOut'];
export type Category = S['CategoryOut'];
export type EstimateRequest = S['EstimateIn'];
export type EstimateResponse = S['EstimateOut'];
export type JobCreate = S['JobCreateIn'];
export type Job = S['JobOut'];
export type Quota = S['QuotaOut'];
export type Lead = S['LeadOut'];
export type LeadPage = S['LeadPageOut'];

export type JobStatus = Job['status'];

// Ordre canonique : trie les runs et choisit la couleur du badge. Défini ici
// pour rester aligné avec l'enum du backend.
export const JOB_STATUS_ORDER: readonly JobStatus[] = [
  'running',
  'pending',
  'paused',
  'cancelling',
  'failed',
  'cancelled',
  'done',
] as const;

export const JOB_STATUS_LABEL: Record<JobStatus, string> = {
  running: 'En cours',
  pending: 'En attente',
  paused: 'En pause',
  cancelling: 'Annulation',
  cancelled: 'Annulé',
  done: 'Terminé',
  failed: 'Échec',
};

export function isActive(status: JobStatus): boolean {
  return status === 'running' || status === 'pending' || status === 'paused'
    || status === 'cancelling';
}
